import React, { useState } from "react";
import { useFormik } from "formik";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { register } from "../_redux/authCrud";
import GenericModal from "../../../components/Modals/GenericModal";

const initialValues = {
  nom: "",
  prenoms: "",
  phone: "",
  email: "",
  password: "",
  changepassword: "",
  acceptTerms: false,
};

function Registration(props) {
  const { intl } = props;
  const [isTermOpen, setIsTermOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error,setError] = useState();
  const RegistrationSchema = Yup.object().shape({
    nom: Yup.string()
      .max(50, "Maximum 50 symbols")
      .required(
          "Champs obligatoire"
      ),
    prenoms: Yup.string()
      .max(50, "Maximum 50 symbols"),
    phone: Yup.string()
        .matches(
            /^[0-9]{10}$/, 'Vous devez saisir un numéro de téléphone valide'
        )
      .required(
          "Champs obligatoire"
      ),
    email: Yup.string()
      .email("Email invalide")
      .required(
          "Champs obligatoire"
      ),
    password: Yup.string()
        .matches(
            /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&"'()§^:;,])[A-Za-z\d@$!%*#?&"'()§^:;,]{8,}$/,
            "Le mot de passe doit contenir au moins 8 caractères, et au moins une majuscule, une minuscule , un chiffre et un symbole"
        )
      .required(
          "Champs obligatoire"
      ),
    changepassword: Yup.string()
      .required(
          "Champs obligatoire"
      )
      .when("password", {
        is: (val) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf(
          [Yup.ref("password")],
          "Les mots de passe ne correspondent pas"
        ),
      }),
    acceptTerms: Yup.bool().required(
      "Vous devez accepter les termes et conditions"
    ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: RegistrationSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();
      setError();
      register(values)
        .then((response) => {

          const accessToken = response.data.token;
          props.register(accessToken);
          disableLoading();
        })
        .catch((error) => {
          setSubmitting(false);
          setError(error);
          disableLoading();
        });
    },
  });

  return (
    <div className="login-form login-signin" style={{ display: "block" }}>
      <div className="text-center mb-10 mb-lg-20">
        <h3 className="font-size-h1">
          Inscription
        </h3>
        <p className="text-muted font-weight-bold">
          Tous les champs marqués d'un astérisque <span className="text-danger">(*)</span> sont obligatoires
        </p>
      </div>

      <form
        id="kt_login_signin_form"
        className="form fv-plugins-bootstrap fv-plugins-framework animated animate__animated animate__backInUp"
        onSubmit={formik.handleSubmit}
      >
        {/* begin: Alert */}
        {formik.status && (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{formik.status}</div>
          </div>
        )}
        {/* end: Alert */}

        {/* begin: Fullname */}
        <div className="form-group fv-plugins-icon-container">
          <label>Nom/Raison sociale <span className="text-danger">*</span></label>
          <input
            placeholder="Nom/Raison sociale"
            type="text"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "nom"
            )}`}
            name="nom"
            {...formik.getFieldProps("nom")}
          />
          {formik.touched.nom && formik.errors.nom ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.nom}</div>
            </div>
          ) : null}
        </div>


        <div className="form-group fv-plugins-icon-container">
          <label>Prénoms </label>
          <input
            placeholder="Prénoms"
            type="text"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "prenoms"
            )}`}
            name="prenoms"
            {...formik.getFieldProps("prenoms")}
          />
          {formik.touched.prenoms && formik.errors.prenoms ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.prenoms}</div>
            </div>
          ) : null}
        </div>


        <div className="form-group fv-plugins-icon-container">
          <label>Numéro de téléphone <span className="text-danger">*</span></label>

          <div className={'d-flex align-items-center'}>
            <div className={'font-weight-bold mr-3'}>+225</div>
            <input
                placeholder="Numéro de téléphone"
                type="text"
                className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
                    "phone"
                )}`}
                name="phone"
                {...formik.getFieldProps("phone")}
            />
          </div>

          {formik.touched.phone && formik.errors.phone ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.phone}</div>
            </div>
          ) : null}
        </div>
        {/* end: Fullname */}

        {/* begin: Email */}
        <div className="form-group fv-plugins-icon-container">
          <label>Email <span className="text-danger">*</span></label>
          <input
            placeholder="Email"
            type="email"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "email"
            )}`}
            name="email"
            {...formik.getFieldProps("email")}
          />
          {formik.touched.email && formik.errors.email ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.email}</div>
            </div>
          ) : null}


          {
            error && error.response && error.response.status == 409 && (
              <div className="small text-danger mt-3 font-weight-bold">
                Cette adresse e-mail est déjà enregistrée
              </div>
            )
          }

        </div>
        {/* end: Email */}

        {/* begin: Password */}
        <div className="form-group fv-plugins-icon-container">
          <label>Mot de passe <span className="text-danger">*</span></label>
          <input
            placeholder="Mot de passe"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "password"
            )}`}
            name="password"
            {...formik.getFieldProps("password")}
          />
          {formik.touched.password && formik.errors.password ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.password}</div>
            </div>
          ) : null}
        </div>
        {/* end: Password */}

        {/* begin: Confirm Password */}
        <div className="form-group fv-plugins-icon-container">
          <label>Confirmation du mot de passe <span className="text-danger">*</span></label>
          <input
            placeholder="Confirmation du mot de passe"
            type="password"
            className={`form-control form-control-solid h-auto py-5 px-6 ${getInputClasses(
              "changepassword"
            )}`}
            name="changepassword"
            {...formik.getFieldProps("changepassword")}
          />
          {formik.touched.changepassword && formik.errors.changepassword ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                {formik.errors.changepassword}
              </div>
            </div>
          ) : null}
        </div>
        {/* end: Confirm Password */}

        {/* begin: Terms and Conditions */}
        <div className="form-group">
          <label className="checkbox">
            <input
              type="checkbox"
              name="acceptTerms"
              {...formik.getFieldProps("acceptTerms")}
            />
            J'accepte les {" "}

            <div onClick={()=>setIsTermOpen(true)}  className={'text-primary d-inline-block'}>
              Termes & Conditions d'utilisation
            </div>
            .
            <span />
          </label>
          {formik.touched.acceptTerms && formik.errors.acceptTerms ? (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">{formik.errors.acceptTerms}</div>
            </div>
          ) : null}
        </div>
        {/* end: Terms and Conditions */}
        <div className="form-group d-flex flex-wrap flex-center">
          <button
            type="submit"
            disabled={formik.isSubmitting || !formik.values.acceptTerms}
            className="btn btn-primary font-weight-bold px-9 py-4 my-3 mx-4"
          >
            <span>Valider</span>
            {loading && <span className="ml-3 spinner spinner-white"></span>}
          </button>

          <Link to="/auth/login">
            <button
              type="button"
              className="btn btn-light-primary font-weight-bold px-9 py-4 my-3 mx-4"
            >
              Annuler
            </button>
          </Link>
        </div>
      </form>

      {
        isTermOpen && (
            <GenericModal
                positiveText={'Ok'}
                onPositive={()=>{
                  setIsTermOpen(false)
                }}
                onNegative={()=>{
                  setIsTermOpen(false)
                }}
                onClose={()=>{
                  setIsTermOpen(false)
                }}
              isOpen={true}
              title={'Conditions générales d\'utilisation'}
            >

              Lorem Ipsum

            </GenericModal>
        )
      }


    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Registration));
